import React, { Fragment, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import CustomLink from "@bit/gerenciatd.unifiedcomponents.custom-link";
import TextInfo, {
  KIND_TEXT,
  COLOR,
  ALIGN,
  SIZE,
  FONT_TYPE,
} from "@bit/gerenciatd.unifiedcomponents.text-info";
import Price, {
  PRICE_COLOR,
  PRICE_DECORATION,
  PRICE_SIZE,
} from "@bit/gerenciatd.unifiedcomponents.price";
import Button, {
  BUTTON_COLOR,
  BUTTON_HEIGHT,
  BUTTON_WIDTH,
} from "@bit/gerenciatd.unifiedcomponents.button";
import Claim, {
  CLAIM_COLOR,
  CLAIM_SIZE,
} from "@bit/gerenciatd.unifiedcomponents.claim";
import SvgIconLabel, {
  SVGICON_LABEL_POSITION,
  SVG_ICON_KIND,
  ICONS_ID,
} from "@bit/gerenciatd.unifiedicons.svg-icon-label";
import SvgIconLoader from "@bit/gerenciatd.unifiedicons.svg-icon-loader";
import {
  BUTTON_CONTENT,
  CUSTOM_LINK_CONTENT,
} from "@bit/gerenciatd.utils.tagging";
import PromoStripExtended from "@bit/gerenciatd.unifiedcomponents.promo-strip-extended";
import { getProductPromotionTextByTextType } from "@bit/gerenciatd.telcovid.common-utils";
import Select from "../Select";
import { useSelectedProductOfGroup } from "../../hooks/useSelectedProductOfGroup";
import { useProductModal } from "../../hooks/useProductModal";
import { actions as fusionActions } from "../../reducers/fusion";
import {
  isPromoInGroup,
  getCheaperPromoPrice,
  getPromosInGroupProducts,
  getReadyParamsDependsOnDowngrade,
} from "../../utils/productUtils";
import {
  showRetentionModal,
  changeTelcoFormatToFrontFormat,
  changeFrontFormatToCompatibleFormat,
} from "./Utils";

import FusionFeatures from "./ProductFeatures";
import "./ProductItem.scss";
import PromotionHired from "./PromotionHired";
import { USER_TYPE } from "../../constants/constants";
import { getFinalInfoForRetentionModal } from "../RetentionModal/Utils";
import moment from "moment";

moment.locale("es");

export const VARIANT = {
  HIRED: "HIRED",
  RECOMMENDED: "RECOMMENDED",
  VINTAGE: "VINTAGE",
};

export const TYPE_PRODUCT = {
  RECOMMENDED: "RECOMMENDED",
  NORMAL: "NORMAL",
};

const COMPONENT_NAME = {
  NORMAL: "FusionItem",
  RECOMMENDED: "recommendationOffer",
};

export const TEXT_TYPES_CODES = {
  ORDINARY: "1",
  ABBREVIATED: "2",
  SHORT: "3",
  EXPLANATORY: "4",
  BRIEF: "5",
  MEDIUM: "6",
  REGULAR_WITH_VALUE: "7",
  ADDITIONAL_SHORT: "8",
  SHORT_EXPLANATORY: "9",
};

export const getProductPromotionTextByType = (productPromotion, textType) => {
  return getProductPromotionTextByTextType(
    productPromotion,
    textType,
    "telcol"
  );
};

export function daysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
}
/**
 * Componente que renderiza la ficha de fusion
 * @param {string} group grupo de productos que obtenermos de prodcategory
 * @param {string} className modificador de la clase de css aplicable al componente
 * @param {string} variant variante de la card del productitem HIRED/RECOMMENDED/(NORMAL)
 * @param {string} productHired Producto contratado obtenido de parque
 * @param {string} productHiredIsOldCatalogue flag para saber si el producto contratado
 * es de catalogo antiguo
 * @param {string} modifierPrice mofificador del precio
 * @param {string} modifierSmartphoneIncludes modificador de precio si incluye smartphone
 * @param {string} taggingInfo información de taggeo
 * @param {string} constants constantes de texto propagadas desde el componente padre
 * @param {string} hiredProductWeights pesos del html de contribucion de el producto contratado.
 * @param {string} dicRepoProductWeights pesos del html de contribucion de el producto a comparar.
 * @param {string} hideColors flag para ocultar los colores o el resaltado de las mejoras/perdidas de la comparación
 * @param {bool} forcedDisabled (opcional) flag para establecer el productItem en modo des-habilitado
 *
 * @returns {jsx}
 *
 * @components {CustomLink} // link customizable
 * @components {TextInfo} // textos
 * @components {SvgIconLoader} // iconos
 * @components {Select} // selector
 * @components {Button} // boton
 */
const ProductItem = ({
  group,
  className = "",
  variant,
  productHired,
  modifierPrice,
  modifierSmartphoneIncludes,
  taggingInfo,
  constants,
  hiredProductWeights,
  dicRepoProductWeights,
  hideColors,
  forcedDisabled,
  history,
  promoStripExtended,
  retentionOffer,
}) => {
  const [promoInGroup, setPromoInGroup] = useState(null);
  const [styleModifier, setStyleModifier] = useState(null);
  const [promoCounter, setpromoCounter] = useState(null);
  const [finalPrice, setFinalPrice] = useState(null);
  const [selectedProduct, setselectedProduct] = useState(null);
  const [hasClientAlreadyDeviceSele, sethasClientAlreadyDevice] = useState("");
  const { data: context } = useSelector((state) => state.context); // context

  const {
    productHired: groupProductHired, // flag para indicar si el cliente ya tiene termiinal
    hasClientAlreadyDevice, // flag para indicar si el cliente ya tiene termiinal
    productHiredUnique, // producto contratado
    productHiredIsOldCatalogue,
  } = useSelector((state) => state.fusion);

  const myHiredProducts = useSelector((state) => state.fusion.myHiredProduct);
  const { userType } = useSelector((state) => state.context.data);
  const dispatch = useDispatch();

  const { prpvCode } = useSelector((state) => state.fusion.products);

  const isPrevention = prpvCode !== "";
  const {
    selectedProduct: selectedProductDefault,
    hasPromo,
    variantSelectors,
  } = useSelectedProductOfGroup(group);
  let isConfig = false;
  if (context && context.userType !== "") {
    isConfig = true;
  }
  const { showProductModal } = useProductModal({ variant });

  let infoForRetentionModal = {
    group,
    variant,
    modifierPrice,
    modifierSmartphoneIncludes,
    constants,
    selectedProduct,
    // le faltan
    groupProductHired, // grupo de productos contratados
    hasClientAlreadyDevice, // flag para indicar si el cliente ya tiene termiinal
    productHiredUnique, // producto contratado
    productHiredIsOldCatalogue, // flag para controlar si el producto contratado
    // pertence al antiguo portfolio
    context, // context
    prpvCode,
  };

  let myHiredProduct = null;
  if (isConfig) {
    if (myHiredProducts && myHiredProducts.length > 0) {
      [myHiredProduct] = myHiredProducts;
    }
    infoForRetentionModal = getFinalInfoForRetentionModal(
      infoForRetentionModal,
      group,
      groupProductHired
    );
  }

  let componentProduct = "";
  if (
    selectedProduct &&
    selectedProduct.product.name &&
    selectedProduct.product.taxonomy
  ) {
    componentProduct = `${selectedProduct.product.name};${selectedProduct.product.taxonomy}`;
  }

  const calculatedTaggingInfo = {
    ...taggingInfo,
    componentName:
      variant === VARIANT.RECOMMENDED
        ? COMPONENT_NAME.RECOMMENDED
        : COMPONENT_NAME.NORMAL,
    componentProduct,
  };

  const taggingInfoModal = {
    ...calculatedTaggingInfo,
  };

  const redirectToConfirmation = () =>
    history.push({
      pathname: "/particulares/fusion/config/confirmacion",
    });

  const redirectToPurchasingProccess = () => {
    window.location.href = selectedProduct.dataMap.urlProdCompra;
  };

  useEffect(() => {
    if (hasClientAlreadyDeviceSele === "") {
      sethasClientAlreadyDevice(hasClientAlreadyDevice);
    }
  }, [hasClientAlreadyDevice, hasClientAlreadyDeviceSele]);

  useEffect(() => {
    if (group && variant !== VARIANT.VINTAGE) {
      setPromoInGroup(isPromoInGroup(group));
      setpromoCounter(getPromosInGroupProducts(group));
      setselectedProduct(productHired || selectedProductDefault);
    }

    if (variant === VARIANT.HIRED) {
      setStyleModifier("--contratado");
    } else if (variant === VARIANT.RECOMMENDED) {
      setStyleModifier("--recomendado");
    } else if (variant === VARIANT.VINTAGE) {
      setStyleModifier("--vintage");
    } else {
      setStyleModifier("");
    }
  }, [group, productHired, selectedProductDefault, variant]);

  useEffect(() => {
    if (selectedProduct && modifierPrice) {
      setFinalPrice(
        parseFloat(selectedProduct.dataMap.pvp, 10) + modifierPrice
      );
    } else if (selectedProduct && !modifierPrice) {
      setFinalPrice(parseFloat(selectedProduct.dataMap.pvp, 10));
    }
  }, [modifierPrice, selectedProduct]);

  if (!selectedProduct && variant !== VARIANT.VINTAGE) {
    return null;
  }

  const labelPromo = hasPromo ? "Cambiar promo" : "Elegir promo";

  const { onClick: downgradeOnClick } = getReadyParamsDependsOnDowngrade(
    infoForRetentionModal.isDowngrade,
    showRetentionModal,
    selectedProduct && selectedProduct.dataMap
      ? selectedProduct.dataMap.urlProdCompra
      : "",
    "clic-boton-meinteresa-distri",
    variant
  );

  const downGradeOnclikcHandler = () => {
    if (downgradeOnClick) {
      showRetentionModal(
        context.device,
        taggingInfo,
        infoForRetentionModal,
        forcedDisabled,
        taggingInfoModal,
        isPrevention,
        redirectToPurchasingProccess
      );
    }
  };

  const {
    link: downGradeButtonLinkFlyOut,
    onClick: downgradeOnClickFlyOut,
  } = getReadyParamsDependsOnDowngrade(
    infoForRetentionModal.isDowngrade,
    showRetentionModal,
    selectedProduct && selectedProduct.dataMap
      ? selectedProduct.dataMap.urlProdCompra
      : "",
    "clic-boton-meinteresa-flyout",
    variant
  );

  const handleClickConfiguration = () => {
    const { name, taxonomy } = selectedProduct.product;

    if (!productHiredIsOldCatalogue) {
      const info = {
        isOpenHiredProduct: variant === VARIANT.HIRED,
        group,
        selectedProduct,
        selected: "CONFIGURATOR",
        promocion: promoInGroup
          ? `Hay ${promoCounter} promociones disponibles`
          : "",
        typeProduct:
          variant === VARIANT.RECOMMENDED
            ? TYPE_PRODUCT.RECOMMENDED
            : TYPE_PRODUCT.NORMAL,
        downGradeButtonLink:
          userType === USER_TYPE.GESTOR && downGradeButtonLinkFlyOut
            ? "/particulares/fusion/config/confirmacion"
            : downGradeButtonLinkFlyOut,
        downgradeOnClick: downgradeOnClickFlyOut,
        isConfig,
        constants,
      };

      if (userType === USER_TYPE.GESTOR && downGradeButtonLinkFlyOut) {
        dispatch(fusionActions.setUrlProdCompra(downGradeButtonLinkFlyOut));
      }

      dispatch(fusionActions.setComponentProduct(`${name};${taxonomy}`));
      showProductModal(info);
    }
  };

  const handleClickIncludes = () => {
    const { name, taxonomy } = selectedProduct.product;

    if (
      (productHiredIsOldCatalogue && variant === VARIANT.HIRED) ||
      variant === VARIANT.VINTAGE
    ) {
      return;
    }

    if (!forcedDisabled) {
      const info = {
        isOpenHiredProduct: variant === VARIANT.HIRED,
        group,
        selectedProduct,
        selected: variant === VARIANT.HIRED ? "CONFIGURATOR" : "INCLUDE",
        promocion: promoInGroup
          ? `Hay ${promoCounter} promociones disponibles`
          : "",
        typeProduct:
          variant === VARIANT.RECOMMENDED
            ? TYPE_PRODUCT.RECOMMENDED
            : TYPE_PRODUCT.NORMAL,
        downGradeButtonLink:
          userType === USER_TYPE.GESTOR && downGradeButtonLinkFlyOut
            ? "/particulares/fusion/config/confirmacion"
            : downGradeButtonLinkFlyOut,
        downgradeOnClick: downgradeOnClickFlyOut,
        isConfig,
        constants,
      };

      if (userType === USER_TYPE.GESTOR && downGradeButtonLinkFlyOut) {
        dispatch(fusionActions.setUrlProdCompra(downGradeButtonLinkFlyOut));
      }

      dispatch(fusionActions.setComponentProduct(`${name};${taxonomy}`));
      showProductModal(info);
    }
  };

  if (!selectedProduct && variant !== VARIANT.VINTAGE) {
    return null;
  }

  let forcedDisablesCss = "";
  if (forcedDisabled) {
    forcedDisablesCss = "disabled";
  }

  let promotionEndDate = null;
  let textoPromo = null;
  let isLastSevenDays = false;
  if (
    context.userType === USER_TYPE.TELCO &&
    myHiredProduct &&
    myHiredProduct.promotions
  ) {
    const { promotions } = myHiredProduct;
    if (promotions && promotions.length > 0) {
      const [promoInfo] = promotions;
      if (promoInfo) {
        const { fechaFin } = promoInfo;
        if (fechaFin) {
          promotionEndDate = changeTelcoFormatToFrontFormat(fechaFin);
          const toDate = new Date(
            changeFrontFormatToCompatibleFormat(promotionEndDate)
          );
          const currentDate = new Date();
          const fromDate = new Date(
            changeFrontFormatToCompatibleFormat(promotionEndDate)
          );
          const dayNumber = currentDate.getDate();
          const startDayNumber = fromDate.getDate();
          if (dayNumber <= 7) {
            const monthNumber = toDate.getMonth();
            fromDate.setMonth(monthNumber - 1);
            const monthDays = daysInMonth(monthNumber, fromDate.getFullYear());
            fromDate.setDate(monthDays - (7 - startDayNumber));
          } else {
            fromDate.setDate(startDayNumber - 7);
          }
          isLastSevenDays = !!(
            currentDate.getTime() <= toDate.getTime() &&
            currentDate.getTime() >= fromDate.getTime()
          );
        }
        if (promoInfo) {
          textoPromo = getProductPromotionTextByType(
            promoInfo,
            TEXT_TYPES_CODES.BRIEF
          );
        }
      }
    }
  }
  const isPromotionHired =
    variant === VARIANT.HIRED &&
    promotionEndDate &&
    textoPromo &&
    isLastSevenDays &&
    context.userType === USER_TYPE.TELCO;
  let isPromotionExclusiveOnline = false;

  const execute = () => {
    const { name, taxonomy } = selectedProduct.product;
    const url = selectedProduct.dataMap.urlProdCompra;

    dispatch(fusionActions.setComponentProduct(`${name};${taxonomy}`));

    if (userType === USER_TYPE.GESTOR) {
      dispatch(fusionActions.setUrlProdCompra(url));
      redirectToConfirmation();
    }

    if (userType !== USER_TYPE.GESTOR) {
      if (downgradeOnClick) {
        downGradeOnclikcHandler();
      } else {
        redirectToPurchasingProccess();
      }
    }
  };

  if (group) {
    isPromotionExclusiveOnline = group.hasPromoOnline;
  }

  return (
    <div
      className={`ProductItem ProductItem${styleModifier} ${className} ${forcedDisablesCss}`}
    >
      {/* Header */}
      <div
        className={`ProductItem__header-wrapper ProductItem__header-wrapper${styleModifier}`}
      >
        <CustomLink
          onClick={handleClickIncludes}
          taggingInfo={{
            ...calculatedTaggingInfo,
            componentContent: CUSTOM_LINK_CONTENT.DEFAULT,
          }}
        >
          <span className="ProductItem__header-title">
            <TextInfo
              text={
                variant === VARIANT.VINTAGE
                  ? "Tu Plan"
                  : selectedProduct.dataMap.nombre
              }
              kind={KIND_TEXT.SPAN}
              align={ALIGN.LEFT}
              color={COLOR.WHITE}
              size={SIZE.TITLE4}
              fontType={FONT_TYPE.LIGHT}
            />
            <div className="cheuron">
              <SvgIconLoader
                id={ICONS_ID.CheuronRight}
                color={COLOR.WHITE}
                kind={SVG_ICON_KIND.MEDIUM}
              />
            </div>
          </span>
          <span className="ProductItem__header-titlepromo">
            {isPromotionExclusiveOnline && variant !== VARIANT.HIRED && (
              <PromoStripExtended
                components={promoStripExtended}
                taggingInfo={{
                  ...taggingInfo,
                  componentContent: "LANDING-FUSION-PromoStripExtended",
                }}
              />
            )}
          </span>

          {!retentionOffer &&
            (variant === VARIANT.HIRED || variant === VARIANT.VINTAGE) && (
              <span className="ProductItem__header-claim">
                <Claim
                  bgColor={CLAIM_COLOR.WHITE}
                  color={CLAIM_COLOR.GREY_6}
                  label="TIENES CONTRATADO"
                  size={CLAIM_SIZE.SMALL}
                />
              </span>
            )}
          {retentionOffer &&
            (variant === VARIANT.HIRED || variant === VARIANT.VINTAGE) && (
              <span className="ProductItem__header-claim">
                <Claim
                  bgColor={CLAIM_COLOR.WHITE}
                  color={CLAIM_COLOR.GREY_6}
                  label="PROMOCION EN TU PRODUCTO CONTRATADO"
                  size={CLAIM_SIZE.SMALL}
                />
              </span>
            )}
          {variant === VARIANT.RECOMMENDED && (
            <span className="ProductItem__header-claim">
              <Claim
                bgColor={CLAIM_COLOR.WHITE}
                color={CLAIM_COLOR.GREEN}
                label="RECOMENDADO PARA TI"
                size={CLAIM_SIZE.SMALL}
              />
            </span>
          )}
        </CustomLink>
      </div>
      {/* contenido */}
      <div className="ProductItem__body-wrapper">
        {variant === VARIANT.VINTAGE ? (
          <div className="ProductItem__body-item ProductItem__body-item--vintage">
            <SvgIconLoader
              id={ICONS_ID.Informacion}
              size={36}
              kind={SVG_ICON_KIND.LIGHT}
              color={COLOR.BLACK}
            />
            <div>
              <TextInfo
                text="¡Lo Sentimos!"
                kind={KIND_TEXT.SPAN}
                align={ALIGN.LEFT}
                color={COLOR.BLACK}
                size={SIZE.TITLE3}
                fontType={FONT_TYPE.REGULAR}
              />
              <TextInfo
                text="<br><br>No podemos recuperar las características de tu Fusión contratado.<br><br> Selecciona tus preferencias y compara entre la oferta Fusión vigente."
                kind={KIND_TEXT.SPAN}
                align={ALIGN.LEFT}
                color={COLOR.GREY_6}
                size={SIZE.CAPTION1}
                fontType={FONT_TYPE.REGULAR}
              />
            </div>
          </div>
        ) : (
          <Fragment>
            <FusionFeatures
              commerInfo={selectedProduct.product.commerInfo}
              variant={variant}
              handleClickIncludes={handleClickIncludes}
              calculatedTaggingInfo={calculatedTaggingInfo}
              modifierSmartphoneIncludes={modifierSmartphoneIncludes}
              hiredProductWeights={hiredProductWeights}
              dicRepoProductWeights={dicRepoProductWeights}
              hideColors={hideColors}
              productHiredIsOldCatalogue={productHiredIsOldCatalogue}
              hasClientAlreadyDevice={hasClientAlreadyDeviceSele}
            />
            {variant === VARIANT.HIRED ? (
              <CustomLink
                onClick={handleClickIncludes}
                taggingInfo={{
                  ...calculatedTaggingInfo,
                  componentContent: CUSTOM_LINK_CONTENT.DEFAULT,
                }}
              >
                <span className="ProductItem__body-item ProductItem__body-item--hired-product">
                  <SvgIconLoader
                    id={ICONS_ID.Producto}
                    size={32}
                    kind={SVG_ICON_KIND.LIGHT}
                    color={COLOR.EGG}
                    className="svg-icon-loader2"
                  />
                  <div className="text-info-wrapper">
                    <TextInfo
                      text={`${selectedProduct.selector.netflix} ${selectedProduct.selector.velocidad}`}
                      kind={KIND_TEXT.PARAGRAPH}
                      align={ALIGN.LEFT}
                      color={COLOR.BLACK}
                      size={SIZE.CAPTION2}
                      fontType={FONT_TYPE.REGULAR}
                    />
                  </div>
                </span>
              </CustomLink>
            ) : (
              <div className="ProductItem__body-item ProductItem__body-item--variant-selectors">
                {Array.isArray(variantSelectors) &&
                  variantSelectors.map((eachVariant) => (
                    <div
                      className="select"
                      key={eachVariant.defaultValue.label}
                    >
                      <Select
                        options={eachVariant.options}
                        defaultValue={eachVariant.defaultValue}
                        onChange={(data) => eachVariant.onChange(data)}
                        taggingInfo={taggingInfo}
                        forcedDisabled={forcedDisabled}
                      />
                    </div>
                  ))}
              </div>
            )}
            {/* promo content */}
            {isPromotionHired && (
              <PromotionHired
                variant={variant}
                promotionEndDate={promotionEndDate}
                textoPromo={textoPromo}
              />
            )}
            {!isPromotionHired && !forcedDisabled && (
              <div
                className={`ProductItem__promo-area ${
                  hasPromo ? "ProductItem__promo-area--applied-promo" : ""
                } ${
                  variant === VARIANT.HIRED
                    ? "ProductItem__promo-area--contratado"
                    : ""
                }`}
              >
                {(promoInGroup || hasPromo) && (
                  <Fragment>
                    <div className="ProductItem__promo-header">
                      <Claim
                        bgColor={
                          isPromotionExclusiveOnline
                            ? CLAIM_COLOR.EGG
                            : CLAIM_COLOR.PURPLE
                        }
                        color={CLAIM_COLOR.WHITE}
                        label={
                          hasPromo
                            ? isPromotionExclusiveOnline
                              ? selectedProduct.dataMap.tituloBandaPromo
                              : "PROMOCIÓN"
                            : variant === VARIANT.HIRED
                            ? ""
                            : "HAY PROMOS DISPONIBLES"
                        }
                        size={CLAIM_SIZE.SMALL}
                      />
                      {variant !== VARIANT.HIRED && (
                        <CustomLink
                          onClick={() => {
                            if (!forcedDisabled) {
                              showProductModal({
                                group,
                                selectedProduct,
                                selected: "PROMO",
                                promocion: promoInGroup
                                  ? `Hay ${promoCounter} promociones disponibles`
                                  : "",
                                typeProduct:
                                  variant === VARIANT.RECOMMENDED
                                    ? TYPE_PRODUCT.RECOMMENDED
                                    : TYPE_PRODUCT.NORMAL,
                                downGradeButtonLink: downGradeButtonLinkFlyOut,
                                downgradeOnClick: downgradeOnClickFlyOut,
                                constants,
                              });
                            }
                          }}
                          taggingInfo={{
                            ...calculatedTaggingInfo,
                            componentContent: labelPromo,
                          }}
                        >
                          <SvgIconLabel
                            id={ICONS_ID.Cheuron}
                            iconSize={10}
                            SvgIconLoader={SvgIconLoader}
                            labelSize={16}
                            label={labelPromo}
                            labelColor={COLOR.BLUE}
                            labelPosition={SVGICON_LABEL_POSITION.LEFT}
                            kind={SVG_ICON_KIND.MEDIUM}
                            iconColor={COLOR.BLUE}
                            className="regular-font"
                          />
                        </CustomLink>
                      )}
                    </div>
                    <TextInfo
                      text={
                        hasPromo
                          ? selectedProduct.dataMap.bandaPromo
                          : variant === VARIANT.HIRED
                          ? ""
                          : `Llévatelo con promo desde ${getCheaperPromoPrice(
                              group
                            )} €`
                      } // TODO De donde sacamos este claim.
                      kind={KIND_TEXT.SPAN}
                      align={ALIGN.LEFT}
                      color={COLOR.GREY_6}
                      size={SIZE.caption01}
                      fontType={FONT_TYPE.REGULAR}
                    />
                  </Fragment>
                )}
              </div>
            )}
          </Fragment>
        )}
      </div>
      {/* price block with button */}
      <div
        className={`ProductItem__footer-wrapper ${
          variant === VARIANT.VINTAGE
            ? "ProductItem__footer-wrapper--vintage"
            : ""
        }`}
      >
        <div className="ProductItem__footer-price">
          {variant !== VARIANT.VINTAGE && selectedProduct.dataMap.pvp && (
            // Si está promocionado tiene pvptachado
            <Fragment>
              {selectedProduct.dataMap.pvpTachado && (
                <Price
                  amount={selectedProduct.dataMap.pvpTachado}
                  unity="€"
                  color={PRICE_COLOR.GREY_5}
                  decoration={PRICE_DECORATION.LINE_THROUGH}
                  size={PRICE_SIZE.REGULAR}
                />
              )}
              <Price
                amount={finalPrice}
                unity={selectedProduct.dataMap.unidad || "€/mes"}
                color={PRICE_COLOR.EGG}
                decoration="none"
                size={
                  selectedProduct.dataMap.pvpTachado
                    ? PRICE_SIZE.SMALL
                    : PRICE_SIZE.REGULAR
                }
              />
            </Fragment>
          )}

          {/* {variant !== VARIANT.VINTAGE && (
            <Price
              amount={finalPrice}
              unity={selectedProduct.dataMap.unidad}
              color={PRICE_COLOR.EGG}
              decoration="none"
              size={PRICE_SIZE.REGULAR}
            />
          )} */}
        </div>

        <div>
          {!forcedDisabled &&
            variant === VARIANT.HIRED &&
            !productHiredIsOldCatalogue && (
              <Button
                color={COLOR.GREEN}
                label="Configurar"
                onClick={handleClickConfiguration}
                taggingInfo={{
                  ...calculatedTaggingInfo,
                  componentContent: "Configurar",
                }}
                size={{
                  w: BUTTON_WIDTH.LIQUID,
                  h: BUTTON_HEIGHT.REGULAR,
                }}
              />
            )}

          {!forcedDisabled &&
            variant !== VARIANT.HIRED &&
            variant !== VARIANT.VINTAGE && (
              <Button
                color={BUTTON_COLOR.GREEN}
                label="Me interesa"
                taggingInfo={{
                  ...calculatedTaggingInfo,
                  componentContent: BUTTON_CONTENT.CTA,
                }}
                size={{
                  w: BUTTON_WIDTH.LIQUID,
                  h: BUTTON_HEIGHT.REGULAR,
                }}
                onClick={execute}
                forceExternal
                target="_self"
              />
            )}
        </div>
      </div>
    </div>
  );
};

export default ProductItem;
